<template>
  <div>
    <Header />
    <img :class="s.homeBanner"
         :src="require('./images/homeBg.jpg')" />
    <div :class="s.headerInfo">
      <div v-for="({ title, text, icon }, index) in INFOS"
           :key="index"
           :class="s.infoSingle">
        <img :src="icon"
             alt="img" />
        <div>
          <h3>{{ title }}</h3>
          <h4>{{ text }}</h4>
          <h5>MORE <i>></i></h5>
        </div>
      </div>
    </div>
    <div :class="s.grayInfoWrap">
      <div :class="s.grayInfo">
        <img :src="require('./images/building.jpg')"
             alt="" />
        <div :class="s.textInfo">
          <h3>关于我们<font>About us</font>
          </h3>
          <h4>公司介绍：</h4>
          <p>
            上海妙保保险经纪股份有限公司（以下简称“妙保经纪”），原名上海同人保险经纪股份有限公司，成立于2010年07月09日，是由中国保险监督管理委员会（以下简称“保监会”）批准成立的一家集寿险、财险为一体，面向个人客户、企业客户进行全方位综合性保险咨询、个性化保险配置和服务的专业化保险经纪机构。
          </p>
          <img :src="require('./images/icons/right.png')"
               alt="" />
        </div>
      </div>
      <!-- 公告 -->
      <div :class="s.Notice">
        <div :class="s.textInfo">
          <h3>公告<font>Notice</font>
          </h3>
          <h4>股权变更公告：</h4>
          <p>上海妙保保险经纪股份有限公司（统一社会信用代码913100005587636058），股东由北京妙佳健康科技有限公司 6345万元(99.140625%)、翟冉 5万元(0.078125%)、赵红文 50万元(0.78125%)，变更为上海利真汽车服务咨询有限公司 6395万元(99.921875%)、汤刚 5万元(0.078125%)。公司在变更前的债权债务及其他纠纷由原股东承担，与新股东无任何关联，特此公告。</p>
          <h4>上海妙保江苏分公司地址变更公告：</h4>
          <p>
<!--            为更好地适应公司经营发展需要，公司将注册地址由南京市秦淮区汉中路1号国际金融中心29层2901室变更为南京市秦淮区中山南路8号-9层-905室，并已领取了新营业执照。本次变更公司注册地址事项仍需向江苏银保监局报告。特此公告-->
            上海妙保保险经纪股份有限公司江苏分公司原地址：南京市秦淮区中山南路8号-9层-905室，变更为：南京市江宁区东山街道绿都大道31号906室。
          </p>
          <h4>换发保险中介许可证公告：</h4>
          <p>上海妙保保险经纪股份有限公司因许可证到期换发新保险中介许可证。</p>
          <p>换发前许可证信息：</p>
          <p>机构名称:上海妙保保险经纪股份有限公司</p>
          <p>地址：上海市静安区沪太路799号4幢501-12室</p>
          <p>许可证流水号：00009392</p>
          <p>机构编码：260860000000800</p>
          <p>设立日期：2010年06月24日</p>
          <p>颁发日期：2025年06月25日</p>
          <p>业务范围：在全国区域内（港、澳、台除外）为投保人拟订投保方案、选择保险人、办理投保手续；协助被保险人或受益人进行索赔；再保险经纪业务；为委托人提供防灾、防损或风险评估、风险管理咨询服务；保险监督管理机构批准的其他业务。</p>
          <p>&nbsp;</p>
          <p>换发后许可证信息：</p>
          <p>机构名称：上海妙保保险经纪股份有限公司</p>
          <p>地址：上海市杨浦区荆州路39号一层1-01室</p>
          <p>许可证流水号：00063227</p>
          <p>机构编码：260860000000800</p>
          <p>设立日期：2010年06月24日</p>
          <p>颁发日期：2026年03月17日</p>
          <p>业务范围：在全国区域内（港、澳、台除外）为投保人拟订投保方案、选择保险人、办理投保手续；协助被保险人或受益人进行索赔；再保险经纪业务；为委托人提供防灾、防损或风险评估、风险管理咨询服务；保险监督管理机构批准的其他业务。</p>
          <h4>地址变更公告：</h4>
          <p>因公司迁址，本机构上海妙保保险经纪股份有限公司苏州分公司（统一社会信用代码：91320581MA1WW4B626），地址由常熟市虞山街道环城南路17号，变更为：常熟市海虞南路1号江南大厦1幢1703。公司类型和经营范围不变。
特此公告</p>
        </div>
      </div>
    </div>

    <Partners />
    <Footer />
  </div>
</template>

<script>
import Header from './components/Header.vue'
import Partners from './components/Partners.vue'
import Footer from './components/Footer.vue'
const INFOS = [
  {
    icon: require('./images/icons/home_1.png'),
    title: '信息查询',
    text: '提供便捷、准确的信息服务',
  },
  {
    icon: require('./images/icons/home_2.png'),
    title: '投保指南',
    text: '量体裁衣，制定有特色的承保方案',
  },
  {
    icon: require('./images/icons/home_3.png'),
    title: '理赔服务',
    text: '提供合理、及时的理赔服务',
  },
]
export default {
  name: 'home',
  components: {
    Header,
    Partners,
    Footer,
  },
  computed: {
    s() {
      return this.$style
    },
  },
  data() {
    return {
      msg: '',
      INFOS,
    }
  },
}
</script>

<style scoped lang="less" module>
h3,
h4,
h5,
p {
  margin: 0;
}
body {
}
.Notice {
  box-sizing: border-box;
//   height: 240px;
  padding: 0 0 60px 0;
  width: 1075px;
  margin: 0 auto;
//   display: flex;
  align-items: center;
  justify-content: space-between;
  text-align: left;
  background-color: #f7f7f7;
  .textInfo {
    color: #666666;
    h3 {
      font-size: 22px;
      font {
        font-size: 12px;
        margin-left: 10px;
      }
    }
    h4 {
      font-size: 14px;
      margin-top: 40px;
    }
    p {
      font-size: 14px;
      margin-top: 12px;
      line-height: 28px;
    }
  }
}

.homeBanner {
  display: block;
  width: 100%;
  //   background: url("./images/homeBg.jpg") center no-repeat;
  //   background-size: contain;
}
.headerInfo {
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: 1075px;
  height: 155px;
  margin: -80px auto 0;
  background-color: #fff;
  position: relative;
  z-index: 2;
}
.infoSingle {
  display: flex;
  align-items: center;
  text-align: left;
  font-size: 12px;
  img {
    margin-right: 12px;
  }
  h3 {
    color: #4869b1;
  }
  h4 {
    color: #000;
  }
  h5 {
    color: #8e8e8e;
  }
  i {
    -webkit-transform: rotateX(120deg);
  }
}
.grayInfoWrap {
  background-color: #f7f7f7;
  width: 100%;
}
.grayInfo {
  box-sizing: border-box;
  height: 400px;
  // padding: 80px 0 0 0;
  width: 1075px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-align: left;
  background-color: #f7f7f7;
  img {
    display: block;
    width: 538px;
    height: 290px;
  }
  .textInfo {
    margin-left: 45px;
    color: #666666;
    img {
      display: block;
      width: 43px;
      height: 9px;
      margin-top: 38px;
    }
    h3 {
      font-size: 22px;
      font {
        font-size: 12px;
        margin-left: 10px;
      }
    }
    h4 {
      font-size: 14px;
      margin-top: 40px;
    }
    p {
      font-size: 14px;
      margin-top: 12px;
      line-height: 28px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue